import { styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { StyledTableRow } from '../../styles';

export const TableRowNew = styled(StyledTableRow)({
  borderBottom: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
  borderTop: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
  backgroundColor: NEW_COLORS.GRAYSCALE[25],
});
